import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@assets/img/Icons/sidebar/profile.svg'
import _imports_1 from '@assets/img/Icons/sidebar/accounts-cards-icon-black.svg'
import _imports_2 from '@assets/img/Icons/sidebar/transfers-icon-black.svg'
import _imports_3 from '@assets/img/Icons/sidebar/transactions.svg'
import _imports_4 from '@assets/img/Icons/sidebar/help.svg'
import _imports_5 from '@assets/img/Icons/sidebar/support-icon-black.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header__user-panel" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "nav-block"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "nav-block"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1)

import { Prop, Vue } from "vue-property-decorator";
import * as Router from "@/router/routerNames";
import { IdentificationNewUser } from "../pages/user-identification";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { AdapterAuthService } from "../pages/login/adapter";
import { AdapterApiService } from "../pages";
import EnumTypeIdentified from "@/api/main/dataSource/api/aba/data/models/models/EnumTypeIdentified";
import IdentificationLegal from "../pages/user-identification/identification-legal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'layout-sidebar',
  props: { show: { type: Boolean, value: true } },
  emits: ["closeMenu"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const router = useRouter();
const route = useRoute();

const windowWidth = ref(window.innerWidth);
// Отслеживаем событие resize
// onMounted(() => {
// 	window.addEventListener('resize', updateWindowWidth);
// });

// // Очищаем слушатель при удалении компонента
// onUnmounted(() => {
// 	window.removeEventListener('resize', updateWindowWidth);
// });
// const updateWindowWidth = () => {
// 	windowWidth.value = window.innerWidth;

// };
function closeMenu() {
  if (windowWidth.value < 991) {
    emits("closeMenu");
  }
}
const minimized = ref(false);

function toggleMinimize() {
  minimized.value = !minimized.value;
}

function isProfileUser(): boolean {
  const res =
    route.name === Router.TRANSFERS ||
    route.name === Router.TRANSUCTIONS ||
    route.name === Router.SUPPORT ||
    route.name === Router.PROFILE_NATURAL ||
    route.name === Router.MESSAGE ||
    route.name === Router.PROFILE_IDENTIFICATION ||
    route.name === Router.BALANCE;

  return res;
}
const adapter = AdapterApiService.getInstance();

const IsIdentified = computed(() => {
  return (
    adapter.userInfo.value.IdentifiedStatus == EnumTypeIdentified.Confirmed
  );
});

function changePage(nameRoute: string) {
  console.log(nameRoute);
  router.push({ name: nameRoute });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", [{ minimized: minimized.value }, { 'show-sidebar': __props.show }]])
  }, [
    _hoisted_1,
    _createElementVNode("nav", null, [
      (
          _ctx.$route.name == Router.PROFILEIDENTIFICATIONLEGAL ||
          _ctx.$route.name === Router.USERIDENTIFICATION ||
          _ctx.$route.name === Router.USERIDENTIFICATIONSIMPLE
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              class: "menu-item",
              to: {}
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Identification")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (isProfileUser())
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "nav-block",
            onClick: closeMenu
          }, [
            (IsIdentified.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "menu-item",
                  to: { name: Router.BALANCE }
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Accounts")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (isProfileUser() && !IsIdentified.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    class: "menu-item",
                    to: { name: Router.PROFILE_IDENTIFICATION }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Identification")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            (IsIdentified.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  class: "menu-item",
                  to: { name: Router.TRANSFERS }
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Transfer")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (IsIdentified.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  class: "menu-item",
                  to: { name: Router.TRANSUCTIONS }
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Transactions")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (IsIdentified.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  class: "menu-item",
                  to: { name: Router.SUPPORT }
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Support")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (IsIdentified.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  class: "menu-item",
                  to: { name: Router.PROFILE_NATURAL }
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Profile")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (IsIdentified.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 6,
                  class: "menu-item",
                  to: { name: Router.MESSAGE }
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Message")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})